module.exports = __webpack_public_path__ + "static/7-fc04583a12c243b1a3d353640378ba40.jpg";